import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'feed-header-period',
    templateUrl: 'feed-header-period.component.html',
    styleUrls: ['./feed-header-period.component.scss'],
    standalone: false
})
export class FeedHeaderPeriodComponent implements OnInit {
    public constructor() {}
    @Input() public periodText = 'Выберите период';
    @Input() public canBeClear = false;
    @Output() public onClear = new EventEmitter();
    @Output() public onClick = new EventEmitter();

    public ngOnInit() {}

    public onClickHandler() {
        this.onClick.emit();
    }

    public onClearHandler() {
        this.onClear.emit();
    }
}
